import { useAuth } from 'react-oidc-context';
import React, { useEffect } from 'react';
import UnAuthorized from '../../routes/unauthorized';
import { BrowserRouter } from 'react-router-dom';
import TokenService from '../../Services/TokenService';

interface PropTypes {
  children: React.ReactElement;
}

// BHP-1040: gate on the OIDC session (react-oidc-context).
// The access token is mirrored to the cookie ApiService reads for Bearer auth.
const AuthCheckProvider = (props: PropTypes): JSX.Element => {
  const auth = useAuth();

  useEffect(() => {
    if (auth.isAuthenticated && typeof auth.user?.access_token === 'string') {
      TokenService.storeAccessTokenCookie(auth.user.access_token, 360);
    }
  }, [auth.isAuthenticated, auth.user]);

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  return auth.isAuthenticated ? (
    <>{props.children}</>
  ) : (
    <BrowserRouter>
      <UnAuthorized />
    </BrowserRouter>
  );
};

export default AuthCheckProvider;
